import { lazy, Suspense } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { Loader } from '@/shared/ui/loader'
import {
  getVisibleIssuanceTabs,
  ISSUANCE_TABS,
} from '@/pages/issuance/model/tabs'

const IssuancePage = lazy(() => import('@/pages/issuance/ui/index'))

const issuanceSearchSchema = z.object({
  tab: z.enum(ISSUANCE_TABS).optional(),
})

export const Route = createFileRoute('/_protected/warehouse/issuance')({
  validateSearch: issuanceSearchSchema,
  // Keep the tab in the URL so a reload lands on the same list, and land on a
  // tab the role may open — a warehouse sees the inbox only.
  beforeLoad: ({ search, context }) => {
    const visibleTabs = getVisibleIssuanceTabs(context.abilityStore.abilities)
    // Nothing to show: let the page render its empty state rather than loop.
    if (visibleTabs.length === 0) return

    if (!search.tab || !visibleTabs.includes(search.tab)) {
      throw redirect({
        to: '/warehouse/issuance',
        search: { tab: visibleTabs[0] },
      })
    }
  },
  component: () => (
    <Suspense fallback={<Loader />}>
      <IssuancePage />
    </Suspense>
  ),
})
